import { onMounted, onUnmounted, shallowRef, watch } from "vue";

/**
 * O título da tela, uma vez só (dono, 25/10): no telefone ele sobe para a barra de
 * cima e o `<h1>` da página fica só para o leitor de tela, como no iOS.
 *
 * A página publica pelo `PageHeader`; a barra lê. Sem barra montada (uma tela
 * pública, a casca do parceiro) o `<h1>` continua à vista.
 */
const published = shallowRef<{ by: symbol; title: string } | null>(null);
const bars = shallowRef(0);

export const barTitle = (): string | null => published.value?.title ?? null;
export const barShowsTitle = (): boolean => bars.value > 0;

/** A barra declara que mostra o título enquanto está montada. */
export function useBarSlot(): void {
	onMounted(() => bars.value++);
	onUnmounted(() => bars.value--);
}

/**
 * Só quem ainda é dono limpa: a tela seguinte monta antes de a anterior desmontar,
 * e um `null` cego apagaria o título que acabou de chegar.
 */
export function usePublishTitle(title: () => string): void {
	const by = Symbol("page-title");
	watch(title, (value) => (published.value = { by, title: value }), { immediate: true });
	onUnmounted(() => {
		if (published.value?.by === by) published.value = null;
	});
}
